module.exports = __webpack_public_path__ + "img/sponsorX19.5a4ec533.png";